function FeatureSection({ feature }) {
    return (
        <div className="flex gap-3">
            <div className='size-7'>
                <img className='size-full' src={feature.imageLink} alt={feature.altText} />
            </div>

            <div className="w-[calc(100%-28px)] flex flex-col">
                <h1 className='font-semibold text-[16px] leading-[26px] text-[#FFFFFF]'>{feature.Heading}</h1>

                <p className='font-medium text-[12px] leading-[22px] text-[#B0B0B0]'>{feature.Description}</p>
            </div>
        </div>
    );
}

function FeaturesOne({ item }) {
    return (
        <div className='flex flex-col gap-3 px-4'>
            {item.item.featureItems.map((feature, index) => {
                return (
                    <FeatureSection 
                        key={index} 
                        feature={feature}
                    />
                )
            })}
        </div>
    );
}

export default FeaturesOne;
